<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <path d="M12 3 4 7l8 4 8-4-8-4z" />
    <path d="M4 7v9l8 4v-9" />
    <path d="M20 7v5" />
    <circle cx="16" cy="16" r="3.5" />
    <path d="m18.475 18.475 2.525 2.525" />
  </svg>
</template>

<script>
export default {}
</script>
